import MarketingHeader from "@/components/MarketingHeader";
import PromoBanner from "@/components/PromoBanner";
import NewMarketingHero from "@/components/NewMarketingHero";
import MembershipCards from "@/components/MembershipCards";
import MarketingFooter from "@/components/MarketingFooter";

export default function Home() {
  return (
    <div className="min-h-screen">
      <MarketingHeader />
      <PromoBanner />
      <NewMarketingHero />
      <div id="pricing">
        <MembershipCards />
      </div>
      <MarketingFooter />
    </div>
  );
}
